import { companyFactLines, nicheNote } from '@/data/companyFacts.mjs';
import { CheckCircle2 } from 'lucide-react';

export default function CompanyFacts() {
  return (
    <section className="py-16 md:py-20 bg-muted/30" aria-labelledby="company-facts-heading">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 id="company-facts-heading" className="text-3xl md:text-4xl font-bold text-foreground mb-8 text-center">Linkzy at a glance</h2>
        <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
          {companyFactLines.map(line => <li key={line} className="flex gap-3 text-foreground leading-relaxed"><CheckCircle2 className="h-5 w-5 shrink-0 mt-1 text-accent" aria-hidden="true" /><span>{line}</span></li>)}
        </ul>
        <p className="mt-8 text-sm text-muted-foreground text-center">{nicheNote}</p>
      </div>
    </section>
  );
}